import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
import { DrawerHeader as DrawerHeaderCL } from 'syf-component-library/ui/atoms';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { defaultCardArt } from '../../const/assets';
import { colors } from '../../defaultTheme';
import { isInstallmentLoan, isSecuredInstallmentLoanProduct } from '../../helpers';
import normalizeStaticHostName from '../../helpers/normalizeStaticHostName';
import { t } from '../../strings/i18n';
import { PaddedSlideInModalLoader } from './styled/PaddedSlideInModalLoader';
const DrawerHeaderWrapper = styled(Inset) `
  border-bottom: 1px solid ${colors.mediumGrey};
  @media ${mediaQueries.lessThanMedium} {
    padding-left: ${spacing.base}px;
    padding-right: ${spacing.base}px;
  }
`;
const DrawerHeader = ({ hosts, accountSummary, isLoading, multiAccountLast4 }) => {
    var _a, _b, _c, _d, _e;
    const staticHostName = normalizeStaticHostName(hosts);
    const displayName = (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _a === void 0 ? void 0 : _a.displayName;
    const productType = (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.type;
    const summaryAccountLast4 = (_c = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.accountInfo) === null || _c === void 0 ? void 0 : _c.accountLast4;
    const accountLast4 = multiAccountLast4 || summaryAccountLast4;
    const headerImage = isSecuredInstallmentLoanProduct(productType)
        ? (_d = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _d === void 0 ? void 0 : _d.portfolioLogo
        : (_e = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.card) === null || _e === void 0 ? void 0 : _e.cardArtURL;
    if (isLoading) {
        return _jsx(PaddedSlideInModalLoader, {});
    }
    const getHeaderSubTitleLabel = () => {
        if (isInstallmentLoan(productType)) {
            return 'loanEndingIn';
        }
        return 'accountEndingIn';
    };
    const drawerHeaderSubtitle = t(`label.${getHeaderSubTitleLabel()}`, {
        accountLast4
    });
    return (_jsx(DrawerHeaderWrapper, Object.assign({ horizontal: "base", vertical: "large" }, { children: _jsx(DrawerHeaderCL, { alt: displayName || 'Card Art', className: "modal-header", "data-cy": "modal-header", fallbackImage: `${staticHostName}${defaultCardArt}`, img: headerImage || `${staticHostName}${defaultCardArt}`, subtitle: drawerHeaderSubtitle, title: displayName }) })));
};
export default DrawerHeader;
